import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailWOValueValidator,
  MobileNoWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";

import { closed } from "../../components/drawer/drawerSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearAgentDetails } from "./agentSlice";
import {
  createAgent,
  getAgentByID,
  getAllAgent,
  updateAgent,
} from "./services/agent.services";
import FormTextArea from "../../components/formFields/FormTextArea";

const CreateAgent: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const AgentDetail = useAppSelector((state) => state.agent.AgentDetail);
  const agent_guid = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.agent.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearAgentDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (agent_guid) {
      dispatch(getAgentByID(agent_guid));
    }
  }, [agent_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!agent_guid) {
        const insertPayload = {
          agent_name: values.agent_name,
          mobile: values.mobile,
          email: values.email,
          address: values.address,
          contact_person: values.contact_person,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createAgent(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearAgentDetails());
          dispatch(getAllAgent());
        }
      } else {
        const editPayload = {
          agent_guid: agent_guid,
          agent_name: values.agent_name,
          mobile: values.mobile,
          email: values.email,
          address: values.address,
          contact_person: values.contact_person,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateAgent(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearAgentDetails());
          dispatch(getAllAgent());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={AgentDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {agent_guid ? "Update Agent" : "Create Agent"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="agent_name"
                label="Agent Name"
                placeholder="Agent Name"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="mobile"
                label="Mobile"
                placeholder="Mobile No"
                type="number"
                max={10}
                component={FormTextField}
                validator={MobileNoWOValueValidator}
                // astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="email"
                label="Email"
                placeholder="example@gmail.com"
                component={FormTextField}
                validator={emailWOValueValidator}
                // astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="address"
                label="Address"
                placeholder="Address"
                component={FormTextArea}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="contact_person"
                label="Contact Person"
                placeholder="Contact Person"
                component={FormTextField}
                // validator={requiredValidator}
                // astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"isactive"}
                component={FormSelectionField}
                label={"Status"}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={agent_guid ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateAgent;
